


















import {
  defineComponent,
  ref
} from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'ProductTab',
  props: {
    title: {
      type: String,
      default: ''
    },
    identifier: {
      type: String,
      default: ''
    },
    open: {
      type: Boolean,
      default: false
    },
    containerClass: {
      type: String,
      default: ''
    }
  },
  setup (props, { emit }) {
    const isActive = ref(false);

    const toggle = () => {
      isActive.value = !isActive.value;
      emit('click:header', isActive ? props.identifier : null);
    }

    return {
      isActive,
      toggle
    }
  }
})
